import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { func_cookieSetting, isNumberValid, isArrayNotEmpty, getStringUniqueId, getArrayLength, isNumber } from "functions";

export function useMainReportColumns() {

    function columns_salesPersonCode() {
        let columnClassName = "column_sales-person-code";

        return {
            Header: " ",
            sticky: "left", 
            isWidthResizingDisabled: true,
            columns: [
                {
                    headerCellClassName: columnClassName,
                    Header: "Sales Person Code",
                    id: "salesPersonCode",
                    accessor: "SalesPersonCode",
                    isWidthResizingDisabled: true,
                    bodyCellClassName: columnClassName,
                    Cell: (props) => {
                        let value = props?.cell?.value;

                        return (
                            <div className={"noWrap-text-ellipsis "}>
                                {value}
                            </div>
                        );
                    },
                }
            ]
        }
    }

    function column_year(index, accessorName) {
        let columnClassName = "column_year";

        return {
            headerCellClassName: columnClassName,
            Header: "Year",
            id: "year" + index,
            accessor: accessorName,
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value?.["Year"];
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value_formatted}
                    </div>
                );
            },
        }
    }

    function column_month(index, accessorName) {
        let columnClassName = "column_month";

        return {
            headerCellClassName: columnClassName,
            Header: "Month",
            id: "month" + index,
            accessor: accessorName,
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let value = props?.cell?.value?.["Month"];
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value_formatted}
                    </div>
                );
            },
        }
    }

    function column_totalOneMonthCommission(index, accessorName) {
        let columnClassName = "column_total-one-month-commmission";

        return {
            headerCellClassName: columnClassName,
            Header: "Total 1 Month Comm",
            id: "totalOneMonthCommission" + index,
            accessor: accessorName,
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value?.["TotalCommission"];
                let value_formatted = isNumberValid(value)? value: "-";
                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value_formatted}
                    </div>
                );
            },
        }
    }

    function column_totalSales(index, accessorName) {
        let columnClassName = "column_total-sales";

        return {
            headerCellClassName: columnClassName,
            Header: "Total Sales",
            id: "totalSales" + index,
            accessor: accessorName,
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value?.["TotalSales"];
                let value_formatted = isNumberValid(value)? value: "-";
                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value_formatted}
                    </div>
                );
            },
        }
    }

    function column_totalCommission(index, accessorName) {
        let columnClassName = "column_total-one-month-commmission";

        return {
            headerCellClassName: columnClassName,
            Header: "Total Comm",
            id: "totalCommission" + index,
            accessor: accessorName,
            bodyCellClassName: columnClassName + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value?.["TotalCommission"];
                let value_formatted = isNumberValid(value)? value: "-";
                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value_formatted}
                    </div>
                );
            },
        }
    }

    function column_commissionData({ headerName, index, accessorName }) {
        let salesColumns = [
            column_totalSales(index, accessorName),
            column_totalCommission(index, accessorName)
        ];
        
        if (index == 0 || index == 2) {
            salesColumns = [
                column_totalOneMonthCommission(index, accessorName),
            ]
        }

        return {
            headerCellClassName: "d-flex justify-content-center",
            Header: headerName,
            id: index + "",
            columns: [
                column_year(index, accessorName),
                column_month(index, accessorName),
                ...salesColumns
            ]
        }
    }

    let commissionColumns = [];
    for (let i = 0; i < 4; i++) {
        let headerName = "", accessorName = "";
        switch (i) {
            case 0: 
                headerName = "Invoice (New Outlet)"; 
                accessorName = "invoiceLevel1";
                break;
            case 1: 
                headerName = "Invoice (Recursive)"; 
                accessorName = "invoiceLevel2";
                break;
            case 2: 
                headerName = "Credit Note (New Outlet)"; 
                accessorName = "creditNoteLevel1";
                break;
            case 3: 
                headerName = "Credit Note (Recursive)";
                accessorName = "creditNoteLevel2";
                break;
        }

        let column = column_commissionData({
            headerName,
            index: i,
            accessorName
        });
        commissionColumns.push(column);
    }


    return [
        columns_salesPersonCode(),
        ...commissionColumns,
    ];
}